import axios, { AxiosResponse } from 'axios';
import { UploadChildrenListRequest, UploadChildrenListResponse, UploadsListRequest, UploadsListResponse } from '@/venit/services/model/techpubs-cms';

export default class UploadsManagementService {

  /** Pobranie listy uploadow z ich statusami (podglad stanu) */
  public list(request: UploadsListRequest): Promise<AxiosResponse<UploadsListResponse>> {
    return axios.post<UploadsListResponse>('/api/admin/upload/list', request);
  }

  public listChildren(request: UploadChildrenListRequest): Promise<AxiosResponse<UploadChildrenListResponse>> {
    return axios.post<UploadsListResponse>('/api/admin/upload/list-children', request);
  }

}
